export enum CardStatusEnum {
  New = 1,
  BankApproved = 2,
  Verified = 3,
  Rejected = 4,
  Canceled = 5,
  Verifying = 6,
}
